import apiCaller from "../../../helper/apiCall";
import { UNION_SALE_ENDPOINTS } from "../../urls/endpoints";
import { UNION_SALE_PROGRAM_CODE } from "../../../constants/unionSale";

const isSendableId = (value) =>
  value !== null && value !== undefined && value !== "" && !Number.isNaN(Number(value));

const buildScopeFilter = (scopeId, unionId) => {
  if (isSendableId(scopeId)) return { scopeId: Number(scopeId) };
  if (isSendableId(unionId)) return { unionId: Number(unionId) };
  return {};
};

const buildFilters = ({ scopeId, unionId, district, distributor } = {}) => ({
  ...buildScopeFilter(scopeId, unionId),
  ...(district ? { district } : {}),
  ...(distributor ? { distributor } : {}),
});

const fetchUnionSaleScopes = async () =>
  apiCaller(UNION_SALE_ENDPOINTS.SCOPES, "POST", {
    programCode: UNION_SALE_PROGRAM_CODE,
  });

const fetchUnionSaleDistributors = async ({ activeOnly } = {}) =>
  apiCaller(UNION_SALE_ENDPOINTS.DISTRIBUTORS, "POST", {
    programCode: UNION_SALE_PROGRAM_CODE,
    ...(activeOnly ? { activeOnly: true } : {}),
  });

const fetchUnionSaleOverview = async ({
  fromDate,
  toDate,
  scopeId,
  unionId,
  district,
  distributor,
  productGroupBy,
  productTopN,
  refresh,
} = {}) =>
  apiCaller(UNION_SALE_ENDPOINTS.OVERVIEW, "POST", {
    programCode: UNION_SALE_PROGRAM_CODE,
    fromDate,
    toDate,
    ...buildFilters({ scopeId, unionId, district, distributor }),
    ...(productGroupBy ? { productGroupBy } : {}),
    ...(productTopN ? { productTopN } : {}),
    ...(refresh ? { refresh: true } : {}),
  });

const fetchUnionSaleUnionWise = async ({
  fromDate,
  toDate,
  scopeId,
  unionId,
  district,
  distributor,
  refresh,
} = {}) =>
  apiCaller(UNION_SALE_ENDPOINTS.UNION_WISE, "POST", {
    programCode: UNION_SALE_PROGRAM_CODE,
    fromDate,
    toDate,
    ...buildFilters({ scopeId, unionId, district, distributor }),
    ...(refresh ? { refresh: true } : {}),
  });

const fetchUnionSaleDistributorMap = async ({ fromDate, toDate, scopeId, unionId, district } = {}) =>
  apiCaller(UNION_SALE_ENDPOINTS.DISTRIBUTOR_MAP, "POST", {
    programCode: UNION_SALE_PROGRAM_CODE,
    fromDate,
    toDate,
    ...buildFilters({ scopeId, unionId, district }),
  });

const fetchUnionSaleTrend = async ({ fromDate, toDate, scopeId, unionId, bucket } = {}) =>
  apiCaller(UNION_SALE_ENDPOINTS.TREND, "POST", {
    programCode: UNION_SALE_PROGRAM_CODE,
    fromDate,
    toDate,
    ...buildFilters({ scopeId, unionId }),
    ...(bucket ? { bucket } : {}),
  });

export {
  fetchUnionSaleScopes,
  fetchUnionSaleDistributors,
  fetchUnionSaleOverview,
  fetchUnionSaleUnionWise,
  fetchUnionSaleDistributorMap,
  fetchUnionSaleTrend,
};
